/* AuraShape — cuenta regresiva REAL al corte de despacho + fechas estimadas de entrega (hora de Lima). */
(function () {
  if (window.__asBuybox) return; window.__asBuybox = true;
  var TZ_OFFSET = -5; // Lima, UTC-5 (sin horario de verano)

  function limaNow() {
    var d = new Date();
    return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + TZ_OFFSET * 3600000);
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(d) {
    var dias = ['dom.', 'lun.', 'mar.', 'mié.', 'jue.', 'vie.', 'sáb.'];
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'set', 'oct', 'nov', 'dic'];
    return dias[d.getDay()] + ' ' + d.getDate() + ' ' + meses[d.getMonth()];
  }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }

  function tick() {
    var now = limaNow();
    document.querySelectorAll('[data-as-cutoff]').forEach(function (el) {
      var hour = parseInt(el.getAttribute('data-hour') || '18', 10);
      var target = new Date(now.getTime()); target.setHours(hour, 0, 0, 0);
      var dayLabel = 'hoy';
      if (now >= target) { target = addDays(target, 1); dayLabel = 'mañana'; }
      var s = Math.max(0, Math.floor((target - now) / 1000));
      var t = el.querySelector('[data-as-cutoff-time]');
      var dl = el.querySelector('[data-as-cutoff-day]');
      if (t) t.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      if (dl) dl.textContent = dayLabel;
    });
  }

  function eta() {
    var now = limaNow();
    document.querySelectorAll('[data-as-eta-lima]').forEach(function (el) {
      el.textContent = fmt(addDays(now, parseInt(el.getAttribute('data-days') || '2', 10)));
    });
    document.querySelectorAll('[data-as-eta-prov]').forEach(function (el) {
      var a = parseInt(el.getAttribute('data-from') || '3', 10), b = parseInt(el.getAttribute('data-to') || '5', 10);
      el.textContent = fmt(addDays(now, a)) + ' – ' + fmt(addDays(now, b));
    });
  }

  /* Selector de packs: marca la tarjeta, desbloquea regalos y pasa la cantidad al formulario (Releasit la lee). */
  var HINTS = {
    1: 'Lleva 1 más y desbloqueas el Ebook GRATIS 📘',
    2: 'Lleva 1 más y desbloqueas la Bolsa de lavado GRATIS 🧺 y el mejor precio',
    3: '¡Desbloqueaste todos los regalos! 🎉'
  };
  function setPack(box, qty) {
    box.querySelectorAll('.as-pk__card').forEach(function (c) {
      var on = c.getAttribute('data-qty') === String(qty);
      c.classList.toggle('is-active', on);
      var r = c.querySelector('input'); if (r) r.checked = on;
    });
    box.querySelectorAll('.as-pk__g').forEach(function (g) {
      var unlocked = qty >= parseInt(g.getAttribute('data-min'), 10);
      if (unlocked && !g.classList.contains('is-on')) { g.classList.add('is-pop'); setTimeout(function () { g.classList.remove('is-pop'); }, 600); }
      g.classList.toggle('is-on', unlocked);
    });
    var h = box.querySelector('[data-as-pk-hint]'); if (h) h.textContent = HINTS[qty] || '';
    /* El pack NO se pasa a la cantidad de la página: Releasit la multiplica por su oferta (3 × 3 = 6
       unidades). La cantidad queda en 1 y el pack se marca dentro del formulario al abrirse. */
    window.__asPack = qty;
    document.querySelectorAll('product-info input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]').forEach(function (q) {
      if (q.value !== '1') { q.value = 1; q.dispatchEvent(new Event('input', { bubbles: true })); q.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    syncOffer();
  }
  /* Marca en el formulario de Releasit la oferta (1, 2 o 3 unidades) igual al pack elegido en la página. */
  function syncOffer() {
    var w = document.getElementById('rsi_form_wrapper'); if (!w || !window.__asPack) return;
    var radios = w.querySelectorAll('input[name="quantity_offer"]');
    var r = radios[window.__asPack - 1];
    if (r && !r.checked) r.click();
  }
  function watchForm() {
    var open = false;
    new MutationObserver(function () {
      var w = document.getElementById('rsi_form_wrapper');
      if (w && !open) {
        open = true;
        /* Releasit monta el formulario y luego re-marca su oferta por defecto: se reintenta hasta que quede. */
        [300, 800, 1400, 2200, 3200].forEach(function (ms) { setTimeout(syncOffer, ms); });
      }
      else if (!w && open) { open = false; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  function packs() {
    document.querySelectorAll('[data-as-packs]').forEach(function (box) {
      box.addEventListener('change', function (e) { if (e.target.name === 'as-pack') setPack(box, parseInt(e.target.value, 10)); });
      var checked = box.querySelector('input[name="as-pack"]:checked');
      setPack(box, checked ? parseInt(checked.value, 10) : 1);
    });
  }

  /* Botones "Quiero mi ErguidaSoft" repartidos por la página: suben al bloque de compra (hero). */
  function ctas() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-as-cta]'); if (!a) return;
      var main = document.querySelector('[id^="MainProduct-"]') || document.querySelector('[id$="__main"]');
      if (!main) return;
      e.preventDefault();
      main.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function reapply() {
    document.querySelectorAll('[data-as-packs]').forEach(function (box) {
      var c = box.querySelector('input[name="as-pack"]:checked'); if (c) setPack(box, parseInt(c.value, 10));
    });
  }
  function start() {
    tick(); eta(); packs(); ctas(); watchForm(); setInterval(tick, 1000);
    // El tema reinicia la cantidad al iniciar: se vuelve a aplicar el pack elegido.
    window.addEventListener('load', function () { setTimeout(reapply, 300); });
    setTimeout(reapply, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
